import { gql, TypedDocumentNode } from '@apollo/client'

import { FilteringRuleSliceDTO } from './types'

export const FILTERING_RULE_FRAGMENT_FOR_CREATE: TypedDocumentNode<FilteringRuleSliceDTO> = gql`
  fragment FilteringRuleFragmentForCreate on FilteringRule {
    id
    name
  }
`
